'use client';

import { syncAnalyticsAttributionState } from '@/analytics/analytics-attribution-state';
import {
  startClarityBootstrap,
  syncClarityUser,
} from '@/analytics/clarity-browser';
import { useAuthSession } from '@/lib/auth/auth-session-provider';
import { matchesRoutePrefix, stripLocalePrefix } from '@/lib/i18n/locale-path';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

function isAdminPath(pathname: string | null) {
  const normalizedPath = stripLocalePrefix(pathname ?? '/');
  return matchesRoutePrefix(normalizedPath, '/admin');
}

export function AnalyticsLazyLoader() {
  const { data: session, isPending } = useAuthSession();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isAdminPath(pathname)) {
      void syncClarityUser(undefined);
      return;
    }

    startClarityBootstrap();
    void syncClarityUser(isPending ? undefined : (session?.user.id ?? null));
  }, [isPending, pathname, session?.user.id]);

  useEffect(() => {
    const nextSearchParams = new URLSearchParams(searchParams.toString());

    syncAnalyticsAttributionState({
      searchParams: nextSearchParams,
    });
  }, [pathname, searchParams]);
  return null;
}
